import axios from "axios";

// 'http://localhost:5000/api/'
// 'https://mymc-api-anndu.ondigitalocean.app/api'
const axiosInstance = axios.create({
  baseURL: "https://mymc-api-anndu.ondigitalocean.app/api",
});

export default axiosInstance;
